import { render } from "./PreLoader.vue?vue&type=template&id=ca9411c4&ts=true"
import script from "./PreLoader.ts?vue&type=script&lang=ts&external"
export * from "./PreLoader.ts?vue&type=script&lang=ts&external"

import "./PreLoader.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__